import { provideFirebaseApp, initializeApp, getApp, getApps } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { environment } from 'src/environments/environment';

const appFactory = () => {
  if (!getApps().length) {
    return initializeApp(environment.firebaseConfig);
  }
  return getApp();
};

export const firebaseAppProviders = [
  provideFirebaseApp(appFactory),
  provideAuth(() => getAuth()),
  provideFirestore(() => getFirestore()),
  provideFunctions(() => getFunctions()),
  provideStorage(() => getStorage()),
];
